export default __webpack_public_path__ + "static/media/recurring-icon.294eba0c.svg";